module.exports = __webpack_public_path__ + "static/logo-f25fa76d87e9d08615eb9dde51cbe4e0.svg";